import { Box, InputAdornment, Link, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CasinoBtnSave from '../../../../components/casino/CasinoBtnSave';
import CusInput from '../../../../components/material-ui/CusInput';
import CusSwitch from '../../../../components/material-ui/CusSwitch';
import TypographyText from '../../../../components/material-ui/table/TypographyText';
import { useTranslation } from 'react-i18next';
import useBootstrapSize from '../../../../hooks/useBootstrapSize';
import { API_CASINO } from '../../../../api/casino';
import useNumberParams from '../../../../hooks/useNumberParams';
import useToast from '../../../../hooks/useToast';
import { useAppSelector } from '../../../../store';
import TgMenuBot from './TgMenuBot';
import { TEST_MODE } from '../../../../enums/enums';
import TgCasinoWebHook from './TgCasinoWebHook';
import CusItemTooltip from '../../../../components/material-ui/CusItemTooltip';
import CusButton from '../../../../components/material-ui/CusButton';
import { IconRefresh } from '@tabler/icons-react';
import IconGenItem from '../../../../components/material-ui/IconGenItem';
import { generateRandomString } from '../../../../utils';

export default function TgCasinoContent() {
  const casinoId = useNumberParams('casinoId');
  const { t } = useTranslation();
  const { successToast } = useToast();
  const { isMobile } = useBootstrapSize();
  const lang = useAppSelector((state) => state.site.lang);

  const [tgSupport, setTgSupport] = useState('');
  const [tgCasinoInfo, setTgCasinoInfo] = useState({
    botName: '',
    apiToken: '',
    secretToken: '',
    domain: '',
    playerInvitation: false
  });

  useEffect(() => {
    if (!casinoId) return;
    if (TEST_MODE) return;

    API_CASINO.tgCasino
      .get({ casinoId, lang })
      .then((e) => {
        const data = e.data.data;
        setTgCasinoInfo({
          apiToken: data.apiToken,
          botName: data.botName,
          secretToken: data.secretToken,
          playerInvitation: data.supportInvite,
          domain: data.domain
        });
        setTgSupport(data.supportChat);
      })
      .catch(console.log);
  }, [casinoId]);

  const onSaveClick = () => {
    console.log('tgCasinoInfo', tgCasinoInfo);

    API_CASINO.tgCasino
      .set({
        casinoId,
        apiToken: tgCasinoInfo.apiToken,
        botName: tgCasinoInfo.botName,
        secretToken: tgCasinoInfo.secretToken,
        supportInvite: tgCasinoInfo.playerInvitation
      })
      .then(() => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  const onGenerate = () => {
    const newSecretToken = generateRandomString(40);
    setTgCasinoInfo((prev) => ({ ...prev, secretToken: newSecretToken }));
  };

  return (
    <Stack gap={5}>
      <Stack gap={2}>
        <Stack gap={1}>
          <CusInput
            label={'Bot name'}
            value={tgCasinoInfo.botName}
            onChange={(e) => setTgCasinoInfo((prev) => ({ ...prev, botName: e.target.value }))}
          />
          <CusInput
            label={'API token'}
            value={tgCasinoInfo.apiToken}
            onChange={(e) => setTgCasinoInfo((prev) => ({ ...prev, apiToken: e.target.value }))}
          />
          <CusInput
            label={'Secret token'}
            value={tgCasinoInfo.secretToken}
            onChange={(e) => setTgCasinoInfo((prev) => ({ ...prev, secretToken: e.target.value }))}
            slotProps={{ input: { sx: { pr: 0 } } }}
            endAdornment={
              <InputAdornment sx={{ m: 0, p: 0 }} position="end">
                <IconGenItem onGenerate={onGenerate} tooltipText="Generate a new secret token" />
              </InputAdornment>
            }
          />
          <CusSwitch
            label={'Send a player an invitation to the support chat'}
            checked={tgCasinoInfo.playerInvitation}
            isColumn={isMobile}
            reverse
            sx={{ width: 'fit-content' }}
            onChange={() =>
              setTgCasinoInfo((prev) => ({
                ...prev,
                playerInvitation: !tgCasinoInfo.playerInvitation
              }))
            }
            tooltipText={
              <TypographyText>
                {t(
                  "A message is sent to a player via the Telegram bot when the bot cannot recognize the player's input. Message text: If you have any difficulties or questions, please contact our support team at"
                )}{' '}
                <Link component="a" target="_blank" href={`https://t.me/${tgSupport}`}>
                  @{tgSupport}
                </Link>
              </TypographyText>
            }
          />
        </Stack>
        <CasinoBtnSave onClick={onSaveClick} />
        <TgCasinoWebHook tgCasinoInfo={tgCasinoInfo} />
      </Stack>

      <TgMenuBot casinoId={casinoId} />
    </Stack>
  );
}
